/** Reads a raw `size` search param as a number, or NaN when it is neither a number nor a non-blank string. */
export function coerceSizeToken(rawSize: unknown): number {
  if (typeof rawSize === 'number') return rawSize;
  if (typeof rawSize === 'string' && rawSize.trim() !== '') return Number(rawSize);
  return Number.NaN;
}
